import gql from "graphql-tag";

export default gql`
  query GetCompanyCustomers($id: ID!) {
    allCustomers(filter: { company: { id: $id } }) {
      id
      name
      address
      email
      phoneNumber
      customerRequestCode
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetCompanyCustomers.ts